import React from 'react';
import Dashboard from '../../layout/Dashboard';
import UserForm from '../../components/forms/UserForm';
import UserFormManager from '../../components/forms/UserFormManager';

const UserAddManager = ({history}) => {
  const user = {
    name: '',
    nickName: '',
    email: '',
    password: '',
  };

  return (
    <Dashboard>
      <UserFormManager history={history} user={user} />
    </Dashboard>
  );
};

export default UserAddManager;
